var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion"},[_c('dt',{staticClass:"tab",on:{"click":_vm.handleTabExpand}},[_c('span',{staticClass:"tab-heading",class:{'-bold': _vm.open}},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"icon icon-arrow-right-grey"})]),_c('dd',{staticClass:"tab-container",class:{'-open': _vm.open}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }